import { render, staticRenderFns } from "./emergencyDetail.vue?vue&type=template&id=32efce38&scoped=true&"
import script from "./emergencyDetail.vue?vue&type=script&lang=js&"
export * from "./emergencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./emergencyDetail.vue?vue&type=style&index=0&id=32efce38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32efce38",
  null
  
)

export default component.exports